import React from "react";
import "./CSS/Categories.css";
import { useNavigate } from "react-router-dom";

import crdbg from "./IMAGES/030baf24263fe4ae6abe7c3522b06880211742a7.png";
import saree from "./IMAGES/Category Saree.png";
import kurti from "./IMAGES/Category Kurti.png";
import dresses from "./IMAGES/Category Dresses.png";
import blouse from "./IMAGES/Category Blouse.png";
import tops from "./IMAGES/Category Tops.png";

const Categories = () => {
  const navigate = useNavigate();

  const data = [
    { title: "Saree", img: saree, bg: crdbg },
    { title: "Kurti Sets", img: kurti, bg: crdbg },
    { title: "Dresses", img: dresses, bg: crdbg },
    { title: "Tops", img: tops, bg: crdbg },
    { title: "Blouse", img: blouse, bg: crdbg },
  ];

  return (
    <div className="categories-container">
      {/* ================= HEADER ================= */}

      <div className="categories-header">
        <div>
          <h1>Exclusive Categories</h1>

          <p>
            Explore our handcrafted collections, tailored for every generation.
          </p>
        </div>
      </div>

      {/* ================= CATEGORY LIST ================= */}

      <div className="categories-card-wrapper">
        {data.map((item, index) => (
          <div
            className="categories-card"
            key={index}
            onClick={() => navigate("/shop")}
          >
            {/* IMAGE CIRCLE */}

            <div className="category-circle">
              <img src={item.img} alt={item.title} />
            </div>

            {/* CATEGORY NAME */}

            <p className="category-name">{item.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Categories;
